/* eslint-disable @typescript-eslint/dot-notation */
import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { ActivatedRoute } from '@angular/router';
import { ContentService } from 'src/app/services/content.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-galleries-edit',
  templateUrl: './galleries-edit.page.html',
  styleUrls: ['./galleries-edit.page.scss'],
})
export class GalleriesEditPage implements OnInit {

  id: any;
  pageArray = [];
  parents = [];
  inc = 0;
  order = {};
  newOrder = [{}];
  page: string;

  constructor(
    private actRoute: ActivatedRoute,
    private contentService: ContentService,
    private fireStore: AngularFirestore,
    private router: Router,
    public authService: AuthenticationService,
  ) { }

  ngOnInit() {
    this.authService.login();
    this.id = this.actRoute.snapshot.paramMap.get('id');
    this.onListGallery();
    this.onGetPage(this.id);
  }

  ionViewWillEnter() {
    if (this.authService.isLoggedIn === false) {
      this.router.navigateByUrl('/admin/login');
    }
  }

  onListGallery() {
    const list = this.contentService.getGallery(this.id);
    list.valueChanges({ idField: 'id' }).subscribe((ss) => {
      this.pageArray = ss;
      console.log(this.pageArray);
    });
  }

  onGetPage(id: string) {
    this.contentService.getPage(id).subscribe(res => {
      const a = res.payload.data();
      // console.log(a["published"]);
      this.page = a['title'];
    });
  }

  drop(event: CdkDragDrop<string[]>) {
    this.newOrder = [{}];
    moveItemInArray(this.pageArray, event.previousIndex, event.currentIndex);

    this.inc = 1000;
    this.pageArray.forEach((val, index) => {
      this.pageArray[index].order = this.inc;
      this.inc += 1000;
      const id = this.pageArray[index].id;
      this.order = {
        order: this.inc,
      };
      this.newOrder.push({
        id: this.pageArray[index].id,
        order: this.inc,
      });

    });
    this.newOrder.shift();
    console.log(this.newOrder);

    const batch = this.fireStore.firestore.batch();
    this.newOrder.forEach((val, index) => {
      const id = this.newOrder[index]['id'];
      const orderNum = this.newOrder[index]['order'];
      console.log (' id:' + id + ' order:' + orderNum);
      const pageRef = this.fireStore.doc(`content/${this.id}/gallery/${id}`).ref;
      batch.update(pageRef, {order:orderNum});
    });
    batch.commit();
  }

  onGalleryDelete(id: string, galleryid: string) {
    this.contentService.deleteGalleryItem(id, galleryid);
  }
}
